import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "mt-3 text-center" }

import {ref} from "vue";
import Cookie from "~/ts/library/Cookie";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "CookieAgreementPopup"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    pdfUrl: {}
  },
  setup(__props: any) {

let props = __props;
const cookieName = "cookiePopupClosed";

let visible = ref(!Cookie.get(cookieName));

function closePopup() {
    Cookie.set(cookieName, '1', 86400 * 3650 * 1000);
    visible.value = false;
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_unref(visible))
    ? (_openBlock(), _createBlock(_component_el_card, {
        key: 0,
        class: "popup",
        shadow: "always"
      }, {
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createTextVNode(" Продолжая пользоваться сайтом, я даю ", -1)),
          _createElementVNode("a", {
            href: __props.pdfUrl,
            target: "_blank"
          }, "согласие", 8, _hoisted_1),
          _cache[2] || (_cache[2] = _createTextVNode(" на использование файлов cookie. ", -1)),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: closePopup
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" ОК ", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})